<template>
  <div class="upload-file">
    <div class="upload-btn">
      <div class="btn-text">选择图片</div>
      <input id="upload-input" @change="fileChange" type="file" ref="file" accept="image/*"></input>
    </div>
    <div class="confirm-btn" @click="chooseImg">确定</div>
    <div class="file-name">{{ fileName }}</div>
  </div>
</template>
<script>
export default {
  name: 'uploadImg',
  data() {
    return {
      type: '',
      file: null,
      cookieStr: '',
      imgStr: ''
    }
  },
  computed: {
    fileName() {
      return this.file && this.file.name || '';
    },
  },
  mounted() {
    this.type = this.$route.query.type || '';
    this.cookieStr = this.$route.query.cookie || '';
    if (this.cookieStr) {
      document.cookie = this.cookieStr;
      console.log('document.cookie:' + document.cookie);
    }
    const s = document.createElement('script');
    s.type = 'text/javascript';
    s.src = 'https://appx/web-view.min.js';
    document.body.appendChild(s);
  },
  methods: {
    fileChange() {
      this.file = this.$refs.file.files[0];
      console.log(this.file);
      let reader = new FileReader();
      reader.readAsDataURL(this.file);
      reader.onload = function () {
        console.log(reader.result); //获取到base64格式图片
        this.imgStr = reader.result.split(',')[1];
      };
    },
    chooseImg() {
      let str = this.imgStr;
      my.setStorageSync({key: 'imgStr', data: str});
      my.navigateBack();
    },
  },
}
</script>

<style lang="scss" scoped>
.upload-file {
  width: 100%;
  min-height: 100vh;
  padding: 20px;
  box-sizing: border-box;

  .upload-btn {
    position: relative;
    display: inline-block;
    width: 80px;
    height: 28px;
    overflow: hidden;
    border-radius: 17px;
    border: 1px solid #3B98F7;
    color: #3B98F7;

    #upload-input {
      position: absolute;
      left: 0;
      top: 0;
      right: 0;
      bottom: 0;
      width: 80px;
      height: 30px;
      opacity: 0;
    }

    .btn-text {
      position: absolute;
      width: 80px;
      height: 30px;
      line-height: 30px;
      text-align: center;
      font-size: 12px;
    }
  }

  .confirm-btn {
    float: right;
    padding: 10px;
    vertical-align: top;
    font-size: 12px;
    color: #3B98F7;
  }

  .file-name {
    margin-top: 15px;
    font-size: 14px;
    color: #333;
    line-height: 18px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/common/uploadImg.vue